module.exports = __webpack_public_path__ + "static/media/016_G6_6Display Artist Detail.cbde2390.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/016_G6_6Display Artist Detail.png
// module id = 441
// module chunks = 0